import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import Intro from "@/components/site/Intro";
import Experience from "@/pages/Experience";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import AuthPage from "@/pages/AuthPage";
import MemberDashboard from "@/pages/MemberDashboard";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import { DialogProvider } from "@/components/site/shared";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Landing() {
  const [entered, setEntered] = useState(false);
  useEffect(() => {
    document.body.style.overflow = entered ? "auto" : "hidden";
  }, [entered]);
  return (
    <DialogProvider>
      <AnimatePresence mode="wait">
        {!entered ? (
          <Intro key="intro" onEnter={() => setEntered(true)} />
        ) : (
          <Experience key="experience" />
        )}
      </AnimatePresence>
    </DialogProvider>
  );
}

function RequireMember({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#050505]"><Loader2 className="h-8 w-8 animate-spin text-gold" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <div className="grain" />
      <Toaster theme="dark" position="top-center" />
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<RequireMember><MemberDashboard /></RequireMember>} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
